import { render, staticRenderFns } from "./dataSource.vue?vue&type=template&id=e1906f08"
import script from "./dataSource.vue?vue&type=script&lang=js"
export * from "./dataSource.vue?vue&type=script&lang=js"
import style0 from "./dataSource.vue?vue&type=style&index=0&id=e1906f08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports